<h1 mat-dialog-title>{{ title }}</h1>

<div class="flex flex-col">
    <!--    ähnliches template auch in select-diary-timespan-dialog.component.html -->
    <mat-slide-toggle [formControl]="FormGroup.controls.exportWorkTimes">Arbeitszeiten mit exportieren</mat-slide-toggle>
    <mat-slide-toggle [formControl]="FormGroup.controls.showFooter">Fußzeile anzeigen</mat-slide-toggle>
    <div class="flex items-center">
        <label id="image-quality-label">Bild Qualität:</label>
        <mat-radio-group aria-labelledby="image-quality-label" [formControl]="FormGroup.controls.imageQuality">
            <mat-radio-button class="m-2" [value]="o.value" *ngFor="let o of imageQualityOptions">{{ o.label }}</mat-radio-button>
        </mat-radio-group>
        <mat-form-field *ngIf="FormGroup.value.imageQuality === imageQualityEnum.custom">
            <mat-label>Auflösung</mat-label>
            <input matInput [placeholder]="defaultResizePixel + ''" type="number" min="1" [formControl]="FormGroup.controls.imageQualityPX" />
            <span matSuffix="px"></span>
            <mat-hint>standard ist {{ defaultResizePixel }}px</mat-hint>
        </mat-form-field>
    </div>
        <div class="flex items-center">
            <label id="image-col-count-label">Bilder nebeneinander:</label>
            <mat-radio-group
                aria-labelledby="image-col-count-label"
                [formControl]="FormGroup.controls.imageColCount">
                <mat-radio-button class="m-2" [value]="1">1</mat-radio-button>
                <mat-radio-button class="m-2" [value]="2">2</mat-radio-button>
                <mat-radio-button class="m-2" [value]="3">3</mat-radio-button>
            </mat-radio-group>
        </div>
<!--    todo D277-4955-->
<!--        <div class="flex items-center">-->
<!--            <label id="image-min-row-count-label">Bilder übereinander (min. pro Seite):</label>-->
<!--            <mat-radio-group-->
<!--                aria-labelledby="image-min-row-count-label"-->
<!--                [formControl]="FormGroup.controls.imageMinRowCount">-->
<!--                <mat-radio-button class="m-2" [value]="1">1</mat-radio-button>-->
<!--                <mat-radio-button class="m-2" [value]="2">2</mat-radio-button>-->
<!--                <mat-radio-button class="m-2" [value]="3">3</mat-radio-button>-->
<!--            </mat-radio-group>-->
<!--        </div>-->
</div>
<mat-dialog-actions class="justify-between">
    <button app-button Inverted Color="cancel" [mat-dialog-close]="">Abbrechen</button>
    <button app-button (click)="submit()">Exportieren</button>
</mat-dialog-actions>
